import { Box, Link, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { DropzoneOptions, useDropzone } from "react-dropzone";

import { ACCEPTED_FILE_TYPES } from "./constants";

import DropzoneImage from "@/assets/svgs/dropzone.svg";

interface Props extends DropzoneOptions {
  hasError?: boolean;
  ref?: null;
  dropzoneHelperText?: string;
}

export function DropArea({
  hasError,
  accept = ACCEPTED_FILE_TYPES,
  disabled,
  dropzoneHelperText = "",
  ...dropzoneOptions
}: Props) {
  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } = useDropzone({
    accept,
    disabled,
    ...dropzoneOptions,
  });

  const theme = useTheme();
  return (
    <Box
      sx={{
        p: 2,
        border: "1px dashed",
        borderRadius: 1,
        borderColor: theme.palette.divider,
        ...(hasError && { borderColor: theme.palette.error.main }),
        ...(isDragReject && { borderColor: theme.palette.error.main }),
        ...(isDragAccept && { borderColor: theme.palette.success.main }),
        ...(isFocused && { borderColor: theme.palette.info.main }),
        transition: theme.transitions.create(["opacity", "border-color"], {
          easing: theme.transitions.easing.easeInOut,
          duration: theme.transitions.duration.shortest,
        }),
        bgcolor: "grey.50",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": { opacity: 0.8 },
        ...(disabled && {
          opacity: `0.6 !important`,
          cursor: "initial",
        }),
      }}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      <Stack direction="row" alignItems="center" spacing={1}>
        <img src={DropzoneImage} alt="Dropzone" style={{ height: "auto", width: 80 }} />
        <Box>
          <Typography variant="subtitle1" color="text.primary">
            Drop or Select file
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Drop files here or click <Link>browse</Link> to search your machine
          </Typography>
          {dropzoneHelperText ? (
            <Typography sx={{ alignItems: "center" }} variant="caption" color="text.secondary">
              {dropzoneHelperText}
            </Typography>
          ) : (
            dropzoneHelperText
          )}
        </Box>
      </Stack>
    </Box>
  );
}
